(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('firebase-token', {
            parent: 'entity',
            url: '/firebase-token?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'bozorakaAdminApp.firebaseToken.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/firebase-token/firebase-tokens.html',
                    controller: 'FirebaseTokenController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('firebaseToken');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('firebase-token-detail', {
            parent: 'firebase-token',
            url: '/firebase-token/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'bozorakaAdminApp.firebaseToken.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/firebase-token/firebase-token-detail.html',
                    controller: 'FirebaseTokenDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('firebaseToken');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'FirebaseToken', function($stateParams, FirebaseToken) {
                    return FirebaseToken.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'firebase-token',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('firebase-token-detail.edit', {
            parent: 'firebase-token-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/firebase-token/firebase-token-dialog.html',
                    controller: 'FirebaseTokenDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['FirebaseToken', function(FirebaseToken) {
                            return FirebaseToken.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('firebase-token.new', {
            parent: 'firebase-token',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/firebase-token/firebase-token-dialog.html',
                    controller: 'FirebaseTokenDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                value: null,
                                language: null,
                                createdBy: null,
                                createdDate: null,
                                lastModifiedBy: null,
                                lastModifiedDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('firebase-token', null, { reload: 'firebase-token' });
                }, function() {
                    $state.go('firebase-token');
                });
            }]
        })
        .state('firebase-token.edit', {
            parent: 'firebase-token',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/firebase-token/firebase-token-dialog.html',
                    controller: 'FirebaseTokenDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['FirebaseToken', function(FirebaseToken) {
                            return FirebaseToken.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('firebase-token', null, { reload: 'firebase-token' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('firebase-token.delete', {
            parent: 'firebase-token',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/firebase-token/firebase-token-delete-dialog.html',
                    controller: 'FirebaseTokenDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['FirebaseToken', function(FirebaseToken) {
                            return FirebaseToken.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('firebase-token', null, { reload: 'firebase-token' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
